import intersection from 'lodash/intersection';

import { addToast } from 'modules/messageSystem/actions/addToast';

import createAction from './';
import {
  INTERNAL_SERVER_ERROR,
  SERVER_IS_UNAVAILABLE,
  INCORRECT_VERIFICATION_TOKENS,
} from '../constants/apiErrorCodes';

export const INCORRECT_VERIFICATION_TOKEN_ACTION = createAction('INCORRECT_VERIFICATION_TOKEN_ACTION');
export const UNEXPECTED_AUTHORIZATION_ERROR_ACTION = createAction('UNEXPECTED_AUTHORIZATION_ERROR_ACTION');

export const handleCommonErrors = (errorCodes, showDefault = true) => (dispatch) => {
  if (errorCodes.includes(INTERNAL_SERVER_ERROR)) {
    return dispatch(addToast('failure', 'internal-server-error-toast', {
      id: 'const.error.internalServerError',
      defaultMessage: '** Internal server error',
    }));
  }

  if (errorCodes.includes(SERVER_IS_UNAVAILABLE)) {
    return dispatch(addToast('failure', 'unavailable-server-error-toast', {
      id: 'const.error.serverIsUnavailable',
      defaultMessage: '** Server is unavailable',
    }));
  }

  if (intersection(errorCodes, INCORRECT_VERIFICATION_TOKENS).length) {
    dispatch({ type: INCORRECT_VERIFICATION_TOKEN_ACTION });
    return dispatch(addToast('failure', 'verification-token-error-toast', {
      id: 'const.error.incorrectVerificationToken',
      defaultMessage: '** Verification token is incorrect',
    }));
  }

  dispatch({ type: UNEXPECTED_AUTHORIZATION_ERROR_ACTION });
  if (showDefault) {
    return dispatch(addToast('failure', 'unexpected-error-toast', {
      id: 'const.error.unexpectedAuthError',
      defaultMessage: '** Sorry, an unexpected error occurred. Please login again.',
    }));
  }
};
